import {
    RxCrop,
    RxDesktop,
    RxPencil2,
    RxReader,
    RxRocket,
    RxAccessibility,
  } from "react-icons/rx";
  
  import glass01 from "../assets/glass-img/a-1.jpg";
  import glass02 from "../assets/glass-img/a-2.jpg";
  import glass03 from "../assets/glass-img/a-3.jpg";
  import glass04 from "../assets/glass-img/a-4.jpg";
  import glass05 from "../assets/glass-img/a-5.jpg";
  import glass06 from "../assets/glass-img/a-6.jpg";
  import glass07 from "../assets/glass-img/a-19.jpg";
  import glass08 from "../assets/glass-img/a-20.jpg";
  
  export const ImageData = [
    {
      icon: RxCrop,
      title: "Development",
      content: "Lorem ipsum dolor sit /amet, consectetur adipiscing elit.",
      backgroundImage: glass01,
    },
    {
      icon: RxPencil2,
      title: "Branding",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      backgroundImage: glass02,
    },
    {
        icon: RxPencil2,
        title: "Branding",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        backgroundImage: glass07,
      },
    {
      icon: RxDesktop,
      title: "Design",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      backgroundImage: glass03,
    },
    {
      icon: RxReader,
      title: "Seo",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      backgroundImage: glass04,
    },
    {
        icon: RxPencil2,
        title: "Branding",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        backgroundImage: glass08,
      },
    {
      icon: RxAccessibility,
      title: "Management",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      backgroundImage: glass05,
    },
    {
      icon: RxRocket,
      title: "Production",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      backgroundImage: glass06,
    },
  ];
  